module.exports = __webpack_public_path__ + "img/Chatapp6.b4709fc8.jpg";